import { PlateHelper } from 'lib_ts/classes/plate.helper';
import { IPitch } from 'lib_ts/interfaces/pitches';
import useMiscStore from 'stores/use-misc-store';

export const CommonPlateLocationGraphic = (props: { pitch: IPitch }) => {
  const summary = PlateHelper.getPitchSummary(props.pitch);

  return (
    <img
      alt="strike zone icon"
      className="StrikeZoneIcon"
      width={24}
      height={24}
      src={useMiscStore.getState().getThemeImgPath(`plate/${summary.grid}.svg`)}
    />
  );
};
